export default class Loader {
    constructor() {
        this.loadCount = 0
        this.forceLoading = false
    }

    async withLoader(func) {
        try {
            this.loadCount++
            await func()
            this.loadCount--
        } catch (ex) {
            this.loadCount--
            throw ex
        }
    }

    setForceLoading(value) {
        this.forceLoading = value
    }

    get isLoading() {
        return this.loadCount > 0 || this.forceLoading
    }
}